import React, { useState, createContext, useContext } from "react";
const OutlineTargetContext = createContext();
const OutlineTargetUpdaterContext = createContext();

export const OutlineProvider = (props) => {
    const [outlineTarget, setOutlineTarget] = useState([]);
    return (<OutlineTargetContext.Provider value={outlineTarget} >
            <OutlineTargetUpdaterContext.Provider value={setOutlineTarget} {...props}/>
        </OutlineTargetContext.Provider>)
};

export const useOutlineTarget = () => {
    const context = useContext(OutlineTargetContext)
    if (!context) {
        throw new Error('useOutlineTarget must be used within a OutlineProvider')
    }
    return context
}

export const useOutlineTargetUpdater = () => {
    const context = useContext(OutlineTargetUpdaterContext)
    if (!context) {
        throw new Error('useOutlineTargetUpdater must be used within a OutlineProvider')
    }
    return context
}